import { ThemeFontDef, ThemeFontName } from './types';

const colors = {
  cream: '#FAF8F1;',
  red: '#e60000',
  white: '#ffffff',
  black: '#242323',
  gray: '#f4f4f4',
  lightGray: '#d4d4d4',
  drkGray: '#4b4b4b',
  silver: '#969696',
  sonicSilver: '#757575',
  darkBlue: '#4b6b90',
  lightBlue: '#e2edf4',
  green: '#2e8540',
  errorRed: '#cd2026',
  hoverRed: '#c7050a',
  pressedRed: '#b50409',
};

// Fonts base
const headline: Partial<ThemeFontDef> = {
  fontFamily: 'var(--ev-header-font)',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '1.2',
};

const eyebrow: Partial<ThemeFontDef> = {
  fontFamily: 'var(--ev-body-font)',
  fontStyle: 'normal',
  fontWeight: '700',
  textTransform: 'uppercase',
  lineHeight: '18px',
  letterSpacing: '0.1em',
};

const subhead: Partial<ThemeFontDef> = {
  fontFamily: 'var(--ev-body-font)',
  fontStyle: 'normal',
  fontWeight: '700',
  letterSpacing: '0.015em',
};

const body: Partial<ThemeFontDef> = {
  fontFamily: 'var(--ev-body-font)',
  fontStyle: 'normal',
  lineHeight: '1.55',
};

const fonts: Record<ThemeFontName, Partial<ThemeFontDef>> = {
  'headline-xl': {
    ...headline,
    fontSize: '60px',
  },
  'headline-lg': {
    ...headline,
    fontSize: '48px',
  },
  'headline-md': {
    ...headline,
    fontSize: '40px',
  },
  'headline-sm': {
    ...headline,
    fontSize: '32px',
  },
  'headline-xs': {
    ...headline,
    fontSize: '26px',
  },
  'headline-xxs': {
    ...headline,
    fontSize: '22px',
  },
  'headline-xxxs': {
    ...headline,
    fontSize: '18px',
  },
  'eyebrow-xl': {
    ...eyebrow,
    fontSize: '20px',
  },
  'eyebrow-lg': {
    ...eyebrow,
    fontSize: '16px',
  },
  'eyebrow-md': {
    ...eyebrow,
    fontSize: '14px',
  },
  'eyebrow-sm': {
    ...eyebrow,
    fontSize: '12px',
  },
  'subhead-xl': {
    ...subhead,
    fontSize: '24px',
    lineHeight: '1.2',
    letterSpacing: '0.01em',
  },
  'subhead-lg': {
    ...subhead,
    fontSize: '20px',
    lineHeight: '1.2',
    letterSpacing: '0.01em',
  },
  'subhead-md': {
    ...subhead,
    fontSize: '18px',
    lineHeight: '1.2',
  },
  'subhead-sm': {
    ...subhead,
    fontSize: '16px',
    lineHeight: '1.375',
  },
  'subhead-xs': {
    ...subhead,
    fontSize: '14px',
    lineHeight: '1.3',
  },

  'body-lg': {
    ...body,
    fontWeight: '400',
    fontSize: '18px',
  },
  'body-lg-light': {
    ...body,
    fontWeight: '300',
    fontSize: '18px',
  },
  'body-md': {
    ...body,
    fontWeight: '400',
    fontSize: '16px',
  },
  'body-md-light': {
    ...body,
    fontWeight: '300',
    fontSize: '16px',
  },
  'body-sm': {
    ...body,
    fontWeight: '400',
    fontSize: '14px',
  },
  'body-sm-light': {
    ...body,
    fontWeight: '300',
    fontSize: '14px',
  },
  'body-xs': {
    ...body,
    fontWeight: '400',
    fontSize: '12px',
  },
  'body-xs-light': {
    ...body,
    fontWeight: '300',
    fontSize: '12px',
  },
  'body-xxs': {
    ...body,
    fontWeight: '400',
    fontSize: '10px',
  },
  'body-xxs-light': {
    ...body,
    fontWeight: '300',
    fontSize: '10px',
  },
};

// NOT SUPPORTED YET (TODO: suppoort)
// Overrides to theme defaults,
// like spacing, border styles, corner radii, named drop-shadow variants etc.
// see `./theme.ts` for all overridable properties
const overrides: any = {}; // TODO: properly derive this type

export type BrandFontName = keyof typeof fonts;
export type BrandColorName = keyof typeof colors;

const theme = {
  colors,
  fonts,
  overrides,
};

export default theme;
